import React from 'react';
import { 
  HelpCircle, 
  FileText, 
  Calendar, 
  DollarSign, 
  AlertTriangle, 
  BookOpen, 
  TrendingDown
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по налогу на прибыль
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: FileText,
      title: 'Документация расходов',
      description: 'Все расходы должны быть экономически обоснованы и документально подтверждены.'
    },
    {
      icon: Calendar,
      title: 'Сроки подачи декларации',
      description: 'Декларация подается не позднее 28 марта года, следующего за отчетным.'
    },
    {
      icon: DollarSign,
      title: 'Авансовые платежи',
      description: 'Уплата авансовых платежей должна производиться не позднее 28 числа месяца, следующего за отчетным периодом.'
    },
    {
      icon: TrendingDown,
      title: 'Перенос убытков',
      description: 'Убытки прошлых лет могут уменьшать налоговую базу не более чем на 50%.'
    },
    {
      icon: BookOpen,
      title: 'Учетная политика',
      description: 'Методы признания доходов и расходов должны быть закреплены в учетной политике организации.'
    },
    {
      icon: AlertTriangle,
      title: 'Контроль расходов',
      description: 'Не все расходы учитываются для целей налогообложения. Проверяйте ст. 270 НК РФ.'
    },
    {
      icon: DollarSign,
      title: 'Амортизация ОС',
      description: 'Выбор метода начисления амортизации влияет на сумму налога на прибыль.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-700 dark:text-indigo-300 mb-2">
              Нужна консультация?
            </h4>
            <p className="text-xs text-indigo-600 dark:text-indigo-400 mb-3">
              Для точного расчета налога и подготовки налоговой декларации рекомендуем обратиться к квалифицированному бухгалтеру или налоговому консультанту.
            </p>
            <button className="w-full py-1.5 text-xs bg-indigo-500 text-white rounded hover:bg-indigo-600 transition-colors">
              Найти налогового консультанта
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;